import { ComponentType } from 'react';
import { ServiceChartCard, ServiceTableCard } from './ServiceCards';
import { MatchChartCard, MatchTableCard } from './MatchCards';
import { EndReasonTypeChartCard, EndReasonTypeTableCard } from './EndReasonTypeCards';
import { FafsaChartCard, FafsaTableCard } from './FafsaDashboard';
import { GenderChartCard, GenderTableCard } from './GenderDashboard';
import { NotificationsCard } from './NotificationsDashboard';
import { TotalStudentsCard } from './StudentDashboard';
import { SchoolEnrollmentCard } from './SchoolEnrollmentDashboard';
import { ParticipantsChartCard, ParticipantsTableCard } from './ParticipantsCards';
import { EligibilityChartCard, EligibilityTableCard } from './EligibilityCards';
import { LkDashboardCardId } from './types';

type DashboardCardComponent = ComponentType<{}>;

export const DASHBOARD_CARD_REGISTRY: Record<number, DashboardCardComponent> = {
  [LkDashboardCardId.ServiceChart]: ServiceChartCard,
  [LkDashboardCardId.ServiceTable]: ServiceTableCard,
  [LkDashboardCardId.MatchChart]: MatchChartCard,
  [LkDashboardCardId.MatchTable]: MatchTableCard,
  [LkDashboardCardId.Notifications]: NotificationsCard,
  [LkDashboardCardId.TotalStudents]: TotalStudentsCard,
  [LkDashboardCardId.SchoolEnrollment]: SchoolEnrollmentCard,
  [LkDashboardCardId.FafsaChart]: FafsaChartCard,
  [LkDashboardCardId.FafsaTable]: FafsaTableCard,
  [LkDashboardCardId.EndReasonTypeTable]: EndReasonTypeTableCard,
  [LkDashboardCardId.EndReasonTypeChart]: EndReasonTypeChartCard,
  [LkDashboardCardId.ParticipantsChart]: ParticipantsChartCard,
  [LkDashboardCardId.ParticipantsTable]: ParticipantsTableCard,
  [LkDashboardCardId.GenderChart]: GenderChartCard,
  [LkDashboardCardId.GenderTable]: GenderTableCard,
  [LkDashboardCardId.EligibilityChart]: EligibilityChartCard,
  [LkDashboardCardId.EligibilityTable]: EligibilityTableCard,
};